import { toTimezone } from 'utils/dateTimeUtils';
import BaseReport from './BaseReport';

class ReportSettings extends BaseReport {
  constructor(params) {
    super(params);

    const {
      createdOn = null,
      updatedOn = null,
      format = null,
      filters = [],
      groupsZone = [],
      othersZone = [],
      aggregatesZone = []
    } = params;
    this.createdOn = toTimezone(createdOn);
    this.updatedOn = toTimezone(updatedOn);
    this.format = format;

    // setup_properties
    this.filters = filters;
    this.groupsZone = groupsZone;
    this.othersZone = othersZone;
    this.aggregatesZone = aggregatesZone;
  }

  // TODO: zone data parsing
}

export default ReportSettings;



// WEBPACK FOOTER //
// ./src/models/Reports/ReportSettings.js